import { render, staticRenderFns } from "./CourierAssignRules.vue?vue&type=template&id=439970f4"
import script from "./CourierAssignRules.vue?vue&type=script&lang=js"
export * from "./CourierAssignRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports